import { useEffect, useState } from 'react';

/*
  Subscribe to a CSS media query from JS.

  For the breakpoints CSS cannot express. CompanyLogo is drawn at a numeric
  pixel size, because uploaded artwork arrives at whatever shape the company has
  and its height is what gets fixed, so a breakpoint that resizes one has to
  change a prop rather than a rule.

  **OnHand's own logo no longer needs this.** It did: the old mark drew at a
  fixed size with a wordmark that could not wrap, so three screens stepped it
  down on narrow widths. The brand guide's lockup is one size per placement, so
  those three callers went on 11 September 2026.

  The query is read during the first render, so the first paint is already
  right rather than correcting itself a frame later.
*/
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = e => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
